module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "squares",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('ul', {
    staticClass: "list_pic clearfix"
  }, _vm._l((_vm.goods), function(item) {
    return _c('li', {
      key: item.goodsId,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "goods-content-v2"
    }, [_c('div', {
      staticClass: "goods-pic"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "goods-pic-tag",
      style: ({
        color: item.topBgcolor
      })
    }, [_vm._v(_vm._s(item.topRightContent))])], 1), _vm._v(" "), _c('div', {
      staticClass: "goods-info"
    }, [(item.name) ? _c('div', {
      staticClass: "goods-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('em', {
      staticClass: "sale-price",
      attrs: {
        "title": '换购商品积分：' + item.exchangePv
      }
    }, [_vm._v(_vm._s(item.exchangePv))]), _vm._v(" "), _c('em', {
      staticClass: "exchange-price",
      attrs: {
        "title": '换购价：' + item.exchangePv
      }
    }, [_vm._v("￥" + _vm._s(item.exchangePv))])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d386bf1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/exchange-goods.vue
// module id = 1666
// module chunks = 1